import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
} from "@mui/material";
import { db } from "../../../config/firebase";
import { COLLECTION } from "../../../data/constant";
import { addDoc, collection } from "firebase/firestore";

const UserRaiseDisputeModal = ({ open, onClose, transaction }) => {
  const [issue, setIssue] = useState("");

  const handleSubmit = async () => {
    if (!transaction || !issue.trim()) return;

    try {
      await addDoc(collection(db, COLLECTION.TRANSACTION_DISPUTES), {
        transactionID: transaction.transactionid || transaction.id,
        phoneNumber: transaction.phoneNumber,
        issueDescription: issue,
        resolutionDescription: null,
        status: "active",
        createdAt: new Date().toISOString(),
      });

      setIssue("");
      onClose();
      window.location.reload()
    } catch (err) {
      console.error("Error submitting dispute:", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ marginLeft: "190px", fontFamily: "montserrat" }}>
        Raise a Dispute
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="Describe your issue"
          multiline
          rows={4}
          value={issue}
          onChange={(e) => setIssue(e.target.value)}
          style={{ marginTop: 10, fontFamily: "montserrat" }}
        />

        <Button
          variant="contained"
          style={{
            backgroundColor: "black",
            color: "white",
            marginTop: 20,
            marginLeft: "180px",
            fontFamily: "montserrat",
          }}
          onClick={handleSubmit}
        >
          Submit Dispute
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default UserRaiseDisputeModal;
